import type { LayoutLoad } from '../../$types';
import { routesPagename } from '$lib/services/urls/routesPagename';

export const load = (async ({ parent, depends }) => {
	depends('zois:init');
	const { zoiResultsStore } = await parent();

	return {
		pagename: routesPagename.ROUTE_RECOMMENDATIONS,
		zoiResultsStore,
	};
}) satisfies LayoutLoad;
